import React from 'react';

export const Testimonial = () => (
  <section className="py-20 px-6 sm:px-10 lg:px-16 bg-[#faf8f5]">
    <div className="max-w-3xl mx-auto text-center">
      <div className="text-6xl text-[#ff5c35]/20 mb-4 font-serif">"</div>
      <blockquote className="text-xl md:text-2xl text-foreground/80 italic mb-6 leading-relaxed">
        We're trying something different with Mindfull. A refreshing approach to remembering the things you care about. One place for everything.
      </blockquote>
      <cite className="text-muted-foreground not-italic font-medium">
        — Timothy, Founder
      </cite>
    </div>
  </section>
);
